<div class="card">
        <div class="card-body">
            <div class="mb-3 d-flex align-items-center justify-content-between">
                <h4 class="mb-2 fw-bolder">Projects List</h4>
                <div class="mb-2">
                    <input
                        type="text"
                        class="form-control mb-3"
                        placeholder="Search user by name"
                        (keyup)="updateFilter($event)"
                    />
                </div>
            </div>
            <div class="table-responsive">
                <ngx-datatable
                    #table
                    [rows]="projectList"
                    [columnMode]="columnMode"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [limit]="10"
                    [selected]="selected"
                    [selectionType]="SelectionType.checkbox"
                    (activate)="onActivate($event)"
                    [rowHeight]="rowHeight"
                    [scrollbarH]="true"
                >
                    
                    <ngx-datatable-column name="Sr. No." [width]="70">
                        <ng-template let-rowIndex="rowIndex" let-row="row" let-value="value" ngx-datatable-cell-template>
                            {{ rowIndex+1 }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Client Name" [width]="200">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <div class="d-flex align-items-center">
                                <div class="">
                                    <!-- <span class="badge-dot me-2" style="position: absolute;top: 4px;" [ngClass]="row['isDemoLive'] === 'isDemo'? 'bg-warning': 'bg-success'"></span> -->
                                    <div class="text-dark">{{row['clientName']}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Captain Email" [width]="200">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            {{row['captainEmail']}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" cellClass="allow-overflow" [width]="60">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <a href="javascript:void(0)" (click)="editProject(row._id)">
                                <div class="d-flex align-items-center edit-btn-svg">
                                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path></svg>
                                    <!--<span class="ms-2">Edit Detail</span>-->
                                </div>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
